import React from "react";

export default function DesignFacet({ handleFilterClick, productDesign }) {
  function sortObject(obj) {
    return Object.keys(obj)
      .sort()
      .reduce((a, v) => {
        a[v] = obj[v];
        return a;
      }, {});
  }
  productDesign = sortObject(productDesign);
  const wpProductCategory = window.wpProductCategory;
  const plpFacetLabel = wpProductCategory.plpFacetLabel;
  const title =
    plpFacetLabel &&
    Object.keys(plpFacetLabel)?.length > 0 &&
    plpFacetLabel.hasOwnProperty("design") &&
    plpFacetLabel.design != ""
      ? plpFacetLabel.design
      : "Style";
  return (
    <div class="facet-wrap facet-display">
      <strong>{title}</strong>
      <div className="facetwp-facet">
        {Object.keys(productDesign).map((design, i) => {
          if (design && productDesign[design] > 0) {
            return (
              <div>
                <span
                  id={`design-filter-${i}`}
                  key={i}
                  data-value={`${design.toLowerCase()}`}
                  onClick={(e) =>
                    handleFilterClick("design", e.target.dataset.value)
                  }>
                  {" "}
                  {design} {` (${productDesign[design]}) `}
                </span>
              </div>
            );
          }
          return null;
        })}
      </div>
    </div>
  );
}
